@if (state.idTags()) {
  @if ((appState.isInErrorState$ | async) === false) {
    <ok-card [loading]="state.loading()">
      <ok-expand-list
        [trackBy]="'id'"
        [sort]="currentSort()"
        [data]="state.idTags().items"
        [itemTemplate]="idTag"
        [configuration]="config()"
        (sortChange)="sortData($event)">
      </ok-expand-list>
      <mat-paginator
        #paginator
        class="paginator"
        [pageSize]="state.viewState().page.pageSize"
        [pageSizeOptions]="state.pagingOptions()"
        [pageIndex]="state.viewState().page.pageIndex"
        [length]="state.idTags().totalCount || 0"
        (page)="pageSwitch($event)"
        color="accent"
        [disabled]="state.loading()" />
    </ok-card>
  }
} @else {
  <div class="no-results align-center">
    <p>Der blev ikke fundet nogen brikker</p>
  </div>
}

<ng-template #idTag let-idTag>
  <ok-card>
    <adm-id-tag-details [idTagId]="idTag.id" />
  </ok-card>
</ng-template>

<ng-template #statusTemplate let-idTag>
  <div class="printed-id-column">
    <div>
      @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Pending]) {
        <svg [matTooltip]="'Afventer behandling'" class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-waiting"></use></svg>
      }
      @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Active]) {
        <svg [matTooltip]="'Aktiv'" class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-available"></use></svg>
      }
      @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Inactive]) {
        <svg [matTooltip]="'Inaktiv'" class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-paused"></use></svg>
      }
      @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.NoIdTagGroup]) {
        <svg [matTooltip]="'Adgang fjernet'" class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-deactivated"></use></svg>
      }
      @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Blocked]) {
        <svg [matTooltip]="'Spærret'" class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-faulted"></use></svg>
      }
    </div>
    <span class="printed-id-icon">
      @if (idTag.idTagType.toString() === idTagTypeEnum[idTagTypeEnum.FleetIdTag]) {
        <svg class="icon-24" aria-hidden="false" aria-label="Flådebrik" [matTooltip]="'Flådebils-brik'">
          <use href="assets/images/ok-icons-sprite.svg#building-s"></use>
        </svg>
      }
      @if (idTag.idTagUserType === idTagUserTypeEnum[idTagUserTypeEnum.CompanyCar]) {
        <mat-icon
          svgIcon="company_car"
          (click)="goToChargingUser(idTag.chargingUserId)"
          alt="Company Car"
          class="clickable"
          [matTooltip]="'Brik er tilknyttet en bruger med firmabil'"></mat-icon>
      }
      @if (
        idTag.idTagType.toString() === idTagTypeEnum[idTagTypeEnum.ChargingUserIdTag] &&
        idTag.idTagUserType !== idTagUserTypeEnum[idTagUserTypeEnum.CompanyCar]
      ) {
        <svg
          class="icon-24 clickable"
          aria-hidden="false"
          (click)="goToChargingUser(idTag.chargingUserId)"
          [matTooltip]="'Brik er tilknyttet en bruger uden firmabil'"
          aria-label="Bruger">
          <use href="assets/images/ok-icons-sprite.svg#user-s"></use>
        </svg>
      }
    </span>
  </div>
</ng-template>

<ng-template #organizationNameTemplate let-idTag>
  <a [routerLink]="['/organizations']" [queryParams]="{ organizationId: idTag.organizationId }">{{ idTag.organizationName }}</a>
</ng-template>

<ng-template #departmentNameTemplate let-idTag>
  <a
    [routerLink]="['/organizations']"
    [queryParams]="{ organizationId: idTag.organizationId, departmentId: idTag.departmentId || idTag.chargingUserDepartmentId }">
    {{ idTag.chargingUserDepartmentName || idTag.departmentName }}
  </a>
</ng-template>

<ng-template #updatedTemplate let-idTag>
  {{ idTag.updated | date: 'short' }}
</ng-template>
